import React, { CSSProperties, PropsWithChildren, useContext, useMemo } from 'react'
import { MultiPaneLayoutContext } from '../multipPaneLayout.context'
import useStyles from './styles'
import { findParentPane } from '../multipPaneLayout.helper'
import { useSelector } from 'react-redux'
import { selectWidgetPaneId } from '../../../selectors/common'

export type SlotContainerProps = {
    paneId: number,
    active: boolean
}

const SlotContainer: React.FC<PropsWithChildren<SlotContainerProps>> = ({ paneId, children, active }) => {
    const layoutContext = useContext(MultiPaneLayoutContext)
    const slotStyles = layoutContext.paneStyles[paneId]
    const { classes, cx } = useStyles()
    const pane = layoutContext.panesConfig[paneId]
    const widgetPaneId = useSelector(selectWidgetPaneId)
    const parentPane = useMemo(() => findParentPane(paneId, layoutContext.panesConfig), [paneId, layoutContext.panesConfig, widgetPaneId])
    const isFullscreen = widgetPaneId === paneId
    const style: CSSProperties = {
        width: isFullscreen ? '100%' : `${slotStyles?.width || 0}px`,
        height: isFullscreen ? '100%' : `${slotStyles?.height || 0}px`,
        left: isFullscreen ? '0%' : `${slotStyles?.left || 0}px`,
        top: isFullscreen ? '0%' : `${slotStyles?.top || 0}px`,
        zIndex: isFullscreen ? 999 : 'auto'
    }
    return <div className={cx(classes.container, { [classes.active]: parentPane && !pane.panes.length && active })}
                style={style} id={`slot-${paneId}`}>{slotStyles && children}</div>
}

export default SlotContainer